
import React from "react";
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url


//created components
import HeaderStep from "../../../commons/headerstep/HeaderStep.jsx";

//MUI
import Alert from '@mui/material/Alert';

//Translate utils :
import { translator } from "../../../utils/translator.js"
import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function Fail() { // component to manage the first step of shopping : choosing place and time
    const { refContrat } = useParams(); //id of the selected house, in url (as string)

    const lang = useSelector(getLang) //global state : language


    return (

        <main>
            <HeaderStep step={0} title={"Erreur lors du paiement"} custom={""} />

            <div className="payment-fail">
                <div className="payment-fail-top">

                    <Alert severity="error"> {translator("Une erreur est survenue lors de paiement", lang, "orderFail1")}</Alert>
                    <p>{translator("Désolé pour ce contre temps (rien n'a été retiré sur votre compte).", lang, "orderFail2")}</p>

                </div>
                <div className="payment-fail-middle">
                    <Alert severity="info">{translator("Vous pouvez revenir sur l'onglet précédent et essayer à nouveau :-)", lang, "orderFail3")}</Alert>
                </div>
                <div className="payment-fail-bottom">

                    <p>{translator("Vous pouvez fermer cet onglet", lang, "orderFail4")}<br></br> ou venez découvrir nos autres activités sur notre site <a href="https://www.moutchicinn.com">moutchicinn.com</a></p>
                </div>

            </div>

        </main>

    )
}




export default Fail